// Prismic defaults
const PRISMIC_API_URL = "https://ucla100.cdn.prismic.io/api/v2";

// Metadata
const DEFAULT_METADATA = {
  title: "UCLA",
  description: "Default UCLA meta description here..",
  image: `/static/images/share.jpg`,
  suffix: "UCLA 100",
  divider: "|"
};

module.exports = {
  PRISMIC_API_URL,
  DEFAULT_METADATA
};
